import http from 'hub-http/clients/apiClient';
export const fetchModuleVersions = query => {
  return http.get('cms-asset-versions/v1/update-module/version-info', {
    query
  });
};